import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AdminNavComponent } from '../../components/admin-nav/admin-nav.component';
import { UsersService } from '../../services/users-service.service';
import { AbuseOverviewDto } from '../../data-transfer-objects/abuse-case.dto';

/**
 * The admin landing page.
 *
 * /admin used to redirect straight through to the users map, which meant the
 * panel had no front door: every section had to be known about in advance and
 * reached by typing its URL. A section nobody can navigate to is a section
 * nobody opens, which is a poor property for a board whose whole job is to be
 * checked.
 *
 * The abuse card carries live counts rather than sitting there as a label, so
 * the landing page answers "is anything waiting for me" without a click.
 */
@Component({
  selector: 'app-admin-home',
  standalone: true,
  imports: [CommonModule, RouterLink, AdminNavComponent],
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
})
export class AdminHomeComponent implements OnInit {
  overview: AbuseOverviewDto | null = null;

  constructor(private usersService: UsersService) {}

  ngOnInit(): void {
    // Best effort: the card still renders without its numbers.
    this.usersService.getAbuseOverview().subscribe({
      next: (o) => (this.overview = o),
      error: () => undefined,
    });
  }

  get needsAttention(): boolean {
    return Boolean(
      this.overview && (this.overview.awaitingReview > 0 || this.overview.reports24h > 0)
    );
  }
}
